module.exports = new __parcel__URL__("73091264-2.9e12101e.png").toString();